
export default {
	name: 'PageFooter',
	computed: {
		curYear ()
		{
			return (new Date()).getFullYear();
		},
		linksList ()
		{
			return [
				[
					{ name: 'Home',           type: 'internal', route: '/' },
					{ name: 'Help Center',    type: 'external', route: 'https://helpcenter.enifex.com/' },
					{ name: 'Terms of Use',   type: 'internal', route: '/terms-of-use' },
					{ name: 'Privacy Policy', type: 'internal', route: '/privacy-policy' },
				],
				[
					{ name: 'About Us',       type: 'internal', route: '/about-us' },
					{ name: 'Contact Us',     type: 'internal', route: '/contact-us' },
				],
			];
		},
		socialMediaList ()
		{
			return [
				{ name: 'Instagram', icon: '$InstagramLogo', route: 'https://www.instagram.com/enifex_official' },
				{ name: 'LinkedIn',  icon: '$LinkedInLogo',  route: 'https://www.linkedin.com/company/enifex/' },
				{ name: 'Telegram',  icon: '$TelegramLogo',  route: 'https://t.me/enifex_EN' },
				{ name: 'Facebook',  icon: '$FacebookLogo',  route: 'https://www.facebook.com/Enifex.official' },
				{ name: 'YouTube',   icon: '$YoutubeLogo',   route: 'https://www.youtube.com/@enifex_official' },
				{ name: 'Discord',   icon: '$DiscordLogo',   route: 'https://discord.gg/DGNA4aYD', class: 'no-fill' },
				{ name: 'Tiktok',    icon: '$TiktokLogo',    route: 'https://www.tiktok.com/@enifex.com' },
			];
		},
	},
};
